import { Configuracion } from './../models/configuracion';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';


@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {

  constructor(
    public http: HttpClient
  ) { }


  configura( configuracion: Configuracion ) {
    let url = URL_SERVICIOS + '/configuracion';
    return this.http.post ( url , configuracion)
    .map (( resp: any ) => {
       console.log (resp);
    });

  }





  activamodo_mtto(valor: boolean, mensaje: string) {
    let url = URL_SERVICIOS + '/configuracion/statusmantenimiento/'+ valor + "/" + mensaje;
    return this.http.get ( url);
   

  }




}
